import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { deletePreviousDocumentQuery } from 'app/edozvola/cases/previous-documents/service/previous-document.queries';
import { useParams } from 'react-router-dom';

export interface IPreviousDocumentsDeleteModal {
  previousDocumentWebId: string;
  isModalOpen: boolean;
  closeModalCallback: Function;
}

const PreviousDocumentsDeleteModal = (props: IPreviousDocumentsDeleteModal) => {
  const { id } = useParams<{ id: string }>();

  const { mutate: deleteMutation } = deletePreviousDocumentQuery(id, props.closeModalCallback);

  return (
    <Modal scrollable isOpen={props.isModalOpen} size={'lg'} toggle={() => props.closeModalCallback()} centered>
      <ModalHeader>
        <span>Brisanje akta</span>
      </ModalHeader>
      <ModalBody>
        <div>Jeste li sigurni da želite obrisati podatke?</div>
      </ModalBody>
      <ModalFooter>
        <Button size={'lg'} label="Odustani" onClick={() => props.closeModalCallback()} />
        <Button size={'lg'} label="Obriši" color={'danger'} onClick={() => deleteMutation(props.previousDocumentWebId)} />
      </ModalFooter>
    </Modal>
  );
};

export default PreviousDocumentsDeleteModal;
